const LTC = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99201 19.9441C15.4795 19.9441 19.928 15.4956 19.928 10.0081C19.928 4.52058 15.4795 0.0720825 9.99201 0.0720825C4.50451 0.0720825 0.056015 4.52058 0.056015 10.0081C0.056015 15.4956 4.50451 19.9441 9.99201 19.9441Z"
      fill="#335E9F"
    />
    <path
      d="M5.57598 16.1039L7.05599 11.2959L5.44398 11.7879L5.87199 10.6039L7.35199 10.1439L9.41999 3.33989C9.46399 3.19589 9.59999 3.09589 9.75199 3.09589H11.864C12.096 3.09589 12.26 3.31989 12.196 3.53989L10.516 9.15589L12.032 8.72789L11.756 9.87189L10.192 10.3439L9.09999 13.8319H14.66C14.828 13.8319 14.948 13.9919 14.904 14.1519L14.42 15.9199C14.388 16.0279 14.292 16.1039 14.176 16.1039H5.57598Z"
      fill="white"
    />
  </svg>
);
export default LTC;
